export const webEndPoint = "https://senthanamuthankidswear.shop/dev_api/api/";
 
// export const webEndPoint = "https://senthanamuthankidswear.shop/prod_api/api/";

// export const razorpayKey = "rzp_test_SkldTbbDq0WGQA";

export const razorpayKey = "rzp_live_SibG79HC3hGoyV"; //Live